import React from "react";
import Field from "./Field";

// Molecule: Field (phone). Reuses the Field shell but slots in an external
// control (the intl PhoneInput, wired up by the organism) as children, so the
// label + message structure stays shared with every other field. Uses the
// phone-specific message spacing variant.
const PhoneField = ({ label, required = false, error, children }) => (
    <Field
        label={label}
        required={required}
        error={error}
        errorClassName="sidebar-quickform-error sidebar-quickform-error-phone"
    >
        <div>{children}</div>
    </Field>
);

export default PhoneField;
